import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "form-success",
  "use": "form-success-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"form-success\"><g fill=\"#00A54B\" fill-rule=\"nonzero\"><path d=\"M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20zm0-2c-9.941 0-18-8.059-18-18S10.059 2 20 2s18 8.059 18 18-8.059 18-18 18z\" /><path d=\"M13.107 20.567l-1.414 1.416 6.535 6.525 10.186-14.26-1.628-1.163-8.814 12.34z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol